import React__default from 'react';
import modules_2ccbe80d from './Logo.module.css.mjs';

const Logo = ({ orgLogo, appLogo })=>{
    if (!orgLogo && !appLogo) return null;
    return /*#__PURE__*/ React__default.createElement("div", {
        className: modules_2ccbe80d.container
    }, orgLogo && /*#__PURE__*/ React__default.createElement("img", {
        className: modules_2ccbe80d.logo,
        src: orgLogo.url,
        alt: orgLogo.alt
    }), appLogo && /*#__PURE__*/ React__default.createElement("img", {
        className: modules_2ccbe80d.logo,
        src: appLogo.url,
        alt: appLogo.alt
    }));
};

export { Logo as default };
//# sourceMappingURL=Logo.mjs.map
